<template>
  <div>
    <base-dialog v-model="dialogVisible" :content="$store.state.dialogMsg"></base-dialog>
    <base-modal v-model="todayHealthConditionGraphVisible" @hidden="todayHealthConditionGraphVisible = false">
      <today-health-condition-chart dynamicXAxis oneValuePerDay
        :label="$t('patient-panel.health-condition-graph-label')" :chartDatas="chartDatas" :focusSeries="chartFocus" />
    </base-modal>
    <health-sliders-modal v-if="$store.getters['session/userHasCompanies'] && !$store.getters['session/userIsCenterEducative'] "  v-model:visible="showHowYouFeel" 
      :variables="[HEALTH_CONDITION_TODAY]" :showTitle="false" @save="onTodayHealthConditionSave"
      hideFooter></health-sliders-modal>
    <div class="row landing-cnt panel-cnt">
      <div class="col-12 my-lg-auto my-0 logged-ctn">
        <div class="logged-title-ctn mb-4 mb-xl-6 mx-auto text-center">
          <h1 class="mb-4 panel">{{ $t('patient-panel.welcome', { platform: getPlatformName }) }}</h1>
          <base-button variant="success" @click="onTodayHealthConditionButtonClick" class="one-liner-btn"
            v-if="$store.state.session.user && $store.getters['session/userHasCompanies'] && !$store.getters['session/userIsCenterEducative']" >
            {{ $t('patient-panel.how-do-you-feel-week', { name: $store.state.session.user.firstName }) }}
          </base-button>
        </div>
        <PatientPanelBlocks></PatientPanelBlocks>
      </div>
      <div class="learn-more" @click="goToSection('integral-solutions')" v-if="!$store.getters['session/isLogged']">
        <span>{{ $t('learn-more-btn') }}</span>
      </div>
    </div>
    <base-dialog :okBtnVisible="false" :cancelFn="() => { showSurveyDialog = false }" v-model="showSurveyDialog"
      :dontShowAgainCookie="surveyDialogKey" :hideFooter="hideSurveyDialogFooter">
      <div class="survey-content">
        <SurveyTest :surveyIdProp="surveyAvailable" @surveyCompleted="handleSurveyCompletion"
          @surveyStarted="handleSurveyStarted" />
      </div>
    </base-dialog>
  </div>
</template>

<script>
import { BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem } from 'bootstrap-vue'
import LangSelector from '@/components/base/LangSelector'
import layoutMixin from '@/mixins/layout.mixin'
import PatientPanelBlocks from '@/components/PatientPanelBlocks'
import { inOpensalud360, getPlatformName } from '@/constants/platformNames'
import { BLUE_COLOUR } from '@/constants/colours'
import BaseDialog from '@/components/base/BaseDialog.vue'
import { UPDATE_HEALTH_CONDITION } from '@/constants/loginOptionalActions'
import { HEALTH_CONDITION_TODAY } from '@/constants/clinicHistory'
import HealthSlidersModal from '@/components/webapp/shared/HealthSlidersModal.vue'
import BaseModal from '@/components/base/BaseModal.vue'
import TodayHealthConditionChart from '@/components/shared/TodayHealthConditionChart.vue'
import SurveyRepository from '@/repositories/SurveyRepository'
import SurveyTest from '../../views/surveys/SurveyTest.vue'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import { hasSufficientData } from '@/helpers/chart.helpers'

export default {
  mixins: [layoutMixin],
  name: 'landing-menu',
  components: {
    'sign-up': () => import('@/components/views/SignUp'),
    BNavbar,
    BNavbarNav,
    BNavbarBrand,
    BNavbarToggle,
    BNavItem,
    BCollapse,
    LangSelector,
    PatientPanelBlocks,
    BaseDialog,
    HealthSlidersModal,
    BaseModal,
    TodayHealthConditionChart,
    SurveyTest
  },
  data () {
    return {
      surveyAvailable: null,
      surveyCompleted: false,
      showSurveyDialog: false,
      hideSurveyDialogFooter: false,
      getPlatformName: getPlatformName(),
      BLUE_COLOUR,
      HEALTH_CONDITION_TODAY,
      todayHealthConditionGraphVisible: false,
      showHowYouFeel: false,
      showMoodSelectorModal: false,
      // Arrays que se cargarán con los datos reales de los estados de ánimo
      chartDatas: {
        variableData: []
        // moodsData: []
      },
      chartFocus: 'variable'
    }
  },
  methods: {
    handleSurveyCompletion () {
      this.surveyCompleted = true
      setTimeout(async () => {
        this.showSurveyDialog = false
        this.hideSurveyDialogFooter = false
        await this.checkSurveyAvailable()
      }, 5000)
    },
    async checkSurveyAvailable () {
      try {
        const response = await SurveyRepository.getSurveyAvailable()
        this.surveyAvailable = response.data
        const pendingActions = this.$store.state.session.loginOptionalActions || []
        const noPendingOptionalActions = pendingActions.length === 0
        if (this.surveyAvailable && !this.hideSurveyDialog && noPendingOptionalActions) {
          this.showSurveyDialog = true
        }
      } catch (error) {
        this.$store.dispatch('showDangerAlert', this.$i18n.t('surveys.error.error-loading'))
      }
    },
    onTodayHealthConditionButtonClick () {
     if (this.$store.state.session.loginOptionalActions.includes(UPDATE_HEALTH_CONDITION)) {
        this.showHowYouFeel = true
      } else {
        this.todayHealthConditionGraphVisible = this.$store.getters['session/userHasCompanies']
      }
    },
    onTodayHealthConditionSave (variableName, values) {
      const value = values[0]
      if (variableName === HEALTH_CONDITION_TODAY) {
        this.showHowYouFeel = false
        if (value > 7) {
          this.$store.dispatch('showSuccessAlert', this.$t('patient-panel.today-health-condition-saved-nice'))
        } else if (value > 4) {
          this.$store.dispatch('showSuccessAlert', this.$t('patient-panel.today-health-condition-saved-ok'))
        } else {
          this.$store.dispatch('showSuccessAlert', this.$t('patient-panel.today-health-condition-saved-bad'))
        }
        this.$store.commit('session/removeLoginOptionalAction', UPDATE_HEALTH_CONDITION)
        this.chartFocus = 'variable'
        // Comprobar si hay suficientes datos en los últimos 6 meses
       try {
        const res = ClinicHistoryRepository().getHistoryChart(HEALTH_CONDITION_TODAY)
        const allData = res.data || []

        // Usa el helper: meses = 6, puntos mínimos = 2
        if (
          hasSufficientData(allData, 6, 2) &&
          this.$store.getters['session/userHasCompanies']
        ) {
          this.todayHealthConditionGraphVisible = true
        }
      } catch (err) {
        console.error('Error comprobando datos históricos:', err)
      }
      }
    },
    handleSurveyStarted () {
      this.hideSurveyDialogFooter = true
    }
  },
  watch: {
    dontShowAgain (value) {
      if (this.surveyAvailable) {
        localStorage.setItem(this.surveyDialogKey, value)
      }
    }
  },
  mounted () {
    if (inOpensalud360() && this.$store.getters['session/userHasCompanies'] === false) {
      this.$router.push('/inicio-sesion')
    }
    this.$store.commit('setLoading', false)
    this.checkSurveyAvailable()
    if (!this.todayHealthConditionCompleted) this.showHowYouFeel = true
  },
  computed: {
    surveyDialogKey () {
      return `hideSurveyDialog_${this.surveyAvailable}`
    },
    hideSurveyDialog () {
      return localStorage.getItem(this.surveyDialogKey) === 'true'
    },
    dialogVisible () {
      return !!this.$store.state.dialogMsg
    },
    todayHealthConditionCompleted () {
      return !(
        this.$store.state.session.loginOptionalActions &&
        this.$store.state.session.loginOptionalActions.includes(UPDATE_HEALTH_CONDITION)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "static-appopensalud/css/public/views/360.scss";

.one-liner-btn {
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/webapp/patient/Panel.vue